import { render } from "./security-list-page.vue?vue&type=template&id=5f3ef094&scoped=true"
import script from "./security-list-page.vue?vue&type=script&lang=js"
export * from "./security-list-page.vue?vue&type=script&lang=js"

import "./security-list-page.vue?vue&type=style&index=0&id=5f3ef094&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3ef094"]])

export default __exports__